/* ==========================================================================
   BOS Tuning — Fahrzeugsuche „Was fährst du?"
   Marke → Modell → Typ (kaskadierend) + HSN/TSN aus dem Fahrzeugschein.
   Die Fahrzeugdaten kommen als JSON direkt aus den `vehicle`-Metaobjekten,
   d. h. ein neu eingepflegtes Fahrzeug taucht ohne Code-Änderung auf.
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE = '(max-width: 700px)';
  var STORE_KEY = 'bos:last-vehicle';

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE).matches;
  }

  /* Vergleichsform: klein, ohne Diakritika, ohne Sonderzeichen — damit
     „Coupe" auch „Coupé" findet und „g20" auch „G20/G21". */
  function norm(s) {
    var t = String(s == null ? '' : s).toLowerCase();
    if (t.normalize) t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return t.replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* Deutsche Schreibvariante (ö → oe), damit „Koenig" auch „König" trifft.
     Wird zusätzlich zur diakritikfreien Form in den Suchtext gelegt. */
  function normDe(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .replace(/\u00e4/g, 'ae').replace(/\u00f6/g, 'oe')
      .replace(/\u00fc/g, 'ue').replace(/\u00df/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function searchKeys() {
    var raw = Array.prototype.filter.call(arguments, Boolean).join(' ');
    var a = norm(raw);
    var b = normDe(raw);
    return a === b ? a : a + ' ' + b;
  }

  function parts(n) {
    return n === 1 ? '1 Teil' : n + ' Teile';
  }

  /* Häkchen für die gewählte Option — das einzige Icon, das per JS entsteht.
     Alle übrigen Icons rendert Liquid über das `bos-icon`-Snippet. */
  function checkIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'bos-ico');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.4');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', 'M20 6 9 17l-5-5');
    svg.appendChild(p);
    return svg;
  }

  /* ========================================================================
     EIN DROPDOWN
     ======================================================================== */
  function VfSelect(root, opts) {
    this.root = root;
    this.onPick = opts.onPick;
    this.label = root.getAttribute('data-vf-label') || '';
    this.placeholder = root.getAttribute('data-vf-placeholder') || this.label;
    this.sheetLabel = root.getAttribute('data-vf-sheet') || this.label;
    this.searchPlaceholder = root.getAttribute('data-vf-search') || 'Suchen …';
    this.emptyText = root.getAttribute('data-vf-empty') || 'Kein Treffer';
    this.lockedText = root.getAttribute('data-vf-locked') || '';

    this.trigger = root.querySelector('[data-vf-trigger]');
    this.valueEl = root.querySelector('[data-vf-value]');
    this.pop = root.querySelector('[data-vf-pop]');
    this.list = root.querySelector('[data-vf-list]');
    this.searchWrap = root.querySelector('[data-vf-search-wrap]');
    this.search = root.querySelector('[data-vf-search]');
    this.noneEl = root.querySelector('[data-vf-none]');
    this.backdrop = root.querySelector('[data-vf-backdrop]');

    this.options = [];
    this.value = null;
    this.open = false;
    this.activeIndex = -1;
    this.typeBuffer = '';
    this.typeTimer = null;

    this.bind();
    this.setOptions([], { locked: true });
  }

  VfSelect.prototype.bind = function () {
    var self = this;

    this.trigger.addEventListener('click', function () {
      self.open ? self.close() : self.openPop();
    });

    this.trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.open) {
        e.preventDefault();
        self.close();
        return;
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        self.openPop();
        return;
      }
      // Direkt lostippen öffnet und filtert — wie bei einem echten Select.
      if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
        self.openPop(e.key);
        e.preventDefault();
      }
    });

    if (this.search) {
      this.search.addEventListener('input', function () {
        self.applyFilter(self.search.value);
      });
    }

    // NUR auf dem Popup lauschen: die Liste liegt darin, keydown blubbert
    // hierher. Ein zweiter Listener auf der Liste würde jeden Tastendruck
    // doppelt verarbeiten (Pfeiltasten überspringen dann jede zweite Option).
    this.pop.addEventListener('keydown', function (e) { self.onPopKey(e); });

    this.list.addEventListener('click', function (e) {
      var li = e.target.closest('[data-vf-opt]');
      if (!li || li.hidden) return;
      self.pick(li.getAttribute('data-vf-opt'), true);
    });

    // Hover markiert die Option, damit Maus und Tastatur denselben Zustand teilen
    this.list.addEventListener('mousemove', function (e) {
      var li = e.target.closest('[data-vf-opt]');
      if (!li || li.hidden) return;
      var i = self.visible().indexOf(li);
      if (i > -1) self.setActive(i, false);
    });

    if (this.backdrop) {
      this.backdrop.addEventListener('click', function () { self.close(); });
    }

    document.addEventListener('pointerdown', function (e) {
      if (!self.open) return;
      if (self.root.contains(e.target)) return;
      self.close();
    });
  };

  VfSelect.prototype.onPopKey = function (e) {
    var vis = this.visible();
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        this.setActive(this.activeIndex + 1 >= vis.length ? 0 : this.activeIndex + 1);
        break;
      case 'ArrowUp':
        e.preventDefault();
        this.setActive(this.activeIndex - 1 < 0 ? vis.length - 1 : this.activeIndex - 1);
        break;
      case 'Home':
        e.preventDefault();
        this.setActive(0);
        break;
      case 'End':
        e.preventDefault();
        this.setActive(vis.length - 1);
        break;
      case 'Enter':
        e.preventDefault();
        if (vis[this.activeIndex]) this.pick(vis[this.activeIndex].getAttribute('data-vf-opt'), true);
        break;
      case 'Escape':
        e.preventDefault();
        this.close(true);
        break;
      case 'Tab':
        // Fokus zuerst auf den Trigger zurückholen, sonst verliert ihn der
        // Browser an <body>, weil das fokussierte Element versteckt wird.
        // Innerhalb des Popups springt Tab zwischen Suchfeld und Liste.
        if (!e.shiftKey && this.usesSearch() && e.target !== this.search) {
          e.preventDefault();
          this.search.focus();
          return;
        }
        // Reihenfolge ist entscheidend: erst auf den sichtbaren Trigger
        // fokussieren, dann das Popup verstecken. Andersherum verliert der
        // Browser den Fokus an <body> und Tab beginnt am Seitenanfang.
        this.trigger.focus();
        this.close();
        break;
      default:
        // Type-ahead, solange kein Suchfeld benutzt wird. Auf `this.search`
        // zu prüfen genügt nicht: das Feld steckt immer im DOM, nur sein
        // Wrapper ist bei wenigen Optionen ausgeblendet.
        if (!this.usesSearch() && e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
          this.typeAhead(e.key);
        }
    }
  };

  VfSelect.prototype.typeAhead = function (ch) {
    var self = this;
    clearTimeout(this.typeTimer);
    this.typeBuffer += ch;
    this.typeTimer = setTimeout(function () { self.typeBuffer = ''; }, 600);
    var q = norm(this.typeBuffer);
    var vis = this.visible();
    for (var i = 0; i < vis.length; i++) {
      if (norm(vis[i].getAttribute('data-vf-search-text')).indexOf(q) === 0) {
        this.setActive(i);
        return;
      }
    }
  };

  /* Einzige Wahrheit dafür, ob das Suchfeld gerade benutzt wird. */
  VfSelect.prototype.usesSearch = function () {
    return !!(this.search && this.searchWrap && !this.searchWrap.hidden);
  };

  VfSelect.prototype.visible = function () {
    return Array.prototype.filter.call(this.list.children, function (li) {
      return !li.hidden && li.hasAttribute('data-vf-opt');
    });
  };

  /* --- Optionen setzen --------------------------------------------------- */
  VfSelect.prototype.setOptions = function (options, cfg) {
    cfg = cfg || {};
    this.options = options || [];
    this.value = null;
    this.list.textContent = '';

    var self = this;
    this.options.forEach(function (o) {
      var li = document.createElement('li');
      li.className = 'bos-vf-select__opt';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('data-vf-opt', o.value);
      li.id = self.root.id + '-opt-' + encodeURIComponent(o.value).replace(/%/g, '_');
      li.setAttribute('data-vf-search-text', searchKeys(o.name, o.meta, o.alt));

      if (o.thumb) {
        var img = document.createElement('img');
        img.className = 'bos-vf-select__opt-thumb';
        img.src = o.thumb;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        li.appendChild(img);
      }

      var main = document.createElement('span');
      main.className = 'bos-vf-select__opt-main';
      var nm = document.createElement('span');
      nm.className = 'bos-vf-select__opt-name';
      nm.textContent = o.name;
      main.appendChild(nm);
      if (o.meta) {
        var mt = document.createElement('span');
        mt.className = 'bos-vf-select__opt-meta';
        mt.textContent = o.meta;
        main.appendChild(mt);
      }
      li.appendChild(main);

      var tick = checkIcon();
      tick.classList.add('bos-vf-select__opt-tick');
      li.appendChild(tick);

      self.list.appendChild(li);
    });

    // Suchfeld nur ab 6 Optionen — bei drei Modellen wäre es nur Ballast.
    if (this.searchWrap) {
      this.searchWrap.hidden = this.options.length < 6;
      if (this.searchWrap.hidden && this.search) this.search.removeAttribute('aria-activedescendant');
      if (this.search) this.search.value = '';
    }

    var locked = !!cfg.locked || this.options.length === 0;
    this.trigger.disabled = locked;
    this.root.classList.toggle('bos-vf-select--filled', false);
    this.root.classList.add('bos-vf-select--empty');
    var lockedLabel = cfg.lockedText || this.lockedText;
    this.valueEl.textContent = locked && lockedLabel ? lockedLabel : this.placeholder;
    this.trigger.setAttribute(
      'aria-label',
      this.label + ': ' + this.valueEl.textContent + (locked ? '' : ', ' + this.options.length + ' Optionen')
    );
    if (locked) this.close();
  };

  /* silent: setzt den Wert, ohne den Kaskaden-Handler auszulösen — nötig, wenn
     der Aufrufer die Kaskade selbst weiterdreht. */
  VfSelect.prototype.pick = function (value, fromUser, silent) {
    var opt = null;
    for (var i = 0; i < this.options.length; i++) {
      if (String(this.options[i].value) === String(value)) { opt = this.options[i]; break; }
    }
    if (!opt) return false;

    this.value = opt.value;
    this.valueEl.textContent = opt.name;
    this.root.classList.remove('bos-vf-select--empty');
    this.root.classList.add('bos-vf-select--filled');
    this.trigger.setAttribute('aria-label', this.label + ': ' + opt.name);

    Array.prototype.forEach.call(this.list.children, function (li) {
      if (!li.hasAttribute('data-vf-opt')) return;
      li.setAttribute('aria-selected', String(li.getAttribute('data-vf-opt') === String(value)));
    });

    this.close();
    if (!silent && this.onPick) this.onPick(opt, !!fromUser);
    return true;
  };

  VfSelect.prototype.openPop = function (seed) {
    if (this.trigger.disabled || this.open) return;
    this.open = true;
    this.pop.hidden = false;
    if (this.backdrop) this.backdrop.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');

    if (isMobile()) document.documentElement.style.overflow = 'hidden';

    /* Das Suchfeld steckt immer im DOM, ist aber unter 6 Optionen ausgeblendet.
       Ein ausgeblendetes Feld kann keinen Fokus annehmen — dann bliebe der
       Fokus am Trigger hängen und Pfeiltasten/Enter kämen nie im Popup an. */
    // Auf dem Smartphone das Suchfeld NICHT automatisch fokussieren (die
    // Tastatur würde das halbe Sheet verdecken) — bedienbar bleibt es trotzdem.
    var useSearch = this.usesSearch() && !isMobile();
    if (useSearch) {
      this.search.value = seed || '';
      this.applyFilter(this.search.value);
      this.search.focus();
    } else {
      if (this.search) this.search.value = '';
      this.applyFilter('');
      this.list.focus();
      if (seed) this.typeAhead(seed);
    }

    // Hat ein getippter Buchstabe bereits etwas markiert, diese Markierung
    // NICHT überschreiben — sonst wählt Enter die falsche Option.
    if (this.activeIndex < 0) {
      var vis = this.visible();
      var start = 0;
      for (var i = 0; i < vis.length; i++) {
        if (vis[i].getAttribute('aria-selected') === 'true') { start = i; break; }
      }
      this.setActive(start);
    }
  };

  VfSelect.prototype.close = function (refocus) {
    if (!this.open) {
      this.pop.hidden = true;
      if (this.backdrop) this.backdrop.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      return;
    }
    this.open = false;
    this.pop.hidden = true;
    if (this.backdrop) this.backdrop.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    this.setActive(-1);
    if (refocus) this.trigger.focus();
  };

  VfSelect.prototype.applyFilter = function (q) {
    var needle = norm(q);
    var shown = 0;
    Array.prototype.forEach.call(this.list.children, function (li) {
      if (!li.hasAttribute('data-vf-opt')) return;
      var hit = !needle || norm(li.getAttribute('data-vf-search-text')).indexOf(needle) !== -1;
      li.hidden = !hit;
      if (hit) shown++;
    });
    if (this.noneEl) {
      // Text vor dem Einblenden setzen, damit role="status" ihn ansagt.
      this.noneEl.textContent = this.emptyText;
      this.noneEl.hidden = shown !== 0;
    }
    this.setActive(shown ? 0 : -1);
  };

  VfSelect.prototype.setActive = function (i, scroll) {
    var vis = this.visible();
    vis.forEach(function (li) { li.classList.remove('is-active'); });
    this.activeIndex = i >= 0 && i < vis.length ? i : -1;
    var owner = this.usesSearch() && document.activeElement === this.search
      ? this.search
      : this.list;
    if (this.activeIndex === -1) {
      owner.removeAttribute('aria-activedescendant');
      return;
    }
    var li = vis[this.activeIndex];
    li.classList.add('is-active');
    owner.setAttribute('aria-activedescendant', li.id);
    if (scroll !== false) {
      if (li.scrollIntoView) li.scrollIntoView({ block: 'nearest' });
    }
  };

  /* ========================================================================
     DIE GANZE FAHRZEUGSUCHE
     ======================================================================== */
  function Finder(root) {
    this.root = root;
    var dataEl = root.querySelector('[data-vf-data]');
    try {
      this.vehicles = JSON.parse(dataEl.textContent).vehicles || [];
    } catch (err) {
      this.vehicles = [];
    }
    this.hsnMap = this.buildHsnMap();

    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vf-tab]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-vf-panel]'));
    this.submit = root.querySelector('[data-vf-submit]');
    this.result = root.querySelector('[data-vf-result]');
    this.resultImg = root.querySelector('[data-vf-result-img]');
    this.resultName = root.querySelector('[data-vf-result-name]');
    this.resultMeta = root.querySelector('[data-vf-result-meta]');
    this.resultGo = root.querySelector('[data-vf-result-go]');
    this.status = root.querySelector('[data-vf-status]');
    this.statusTitle = root.querySelector('[data-vf-status-title]');
    this.statusText = root.querySelector('[data-vf-status-text]');
    this.statusActions = root.querySelector('[data-vf-status-actions]');
    this.live = root.querySelector('[data-vf-live]');
    this.resetBtn = root.querySelector('[data-vf-reset]');
    this.recent = root.querySelector('[data-vf-recent]');
    this.recentLink = root.querySelector('[data-vf-recent-link]');
    this.recentName = root.querySelector('[data-vf-recent-name]');
    this.recentClear = root.querySelector('[data-vf-recent-clear]');

    this.hsnInput = root.querySelector('[data-vf-hsn]');
    this.tsnInput = root.querySelector('[data-vf-tsn]');
    this.kbaSubmit = root.querySelector('[data-vf-kba-submit]');
    this.helpBtn = root.querySelector('[data-vf-help]');
    this.helpBox = root.querySelector('[data-vf-hint]');

    this.current = null;
    this.currentSource = null;
    this.currentTab = 0;
    // Erst wenn der Kunde selbst etwas gewählt hat, ist „Zurücksetzen" sinnvoll —
    // die automatische Vorauswahl einer einzigen Marke zählt nicht.
    this.touched = false;
    this.autoSelectSingle = root.getAttribute('data-vf-auto-single') !== 'false';

    var self = this;
    // Ohne Fahrzeuge rendert Liquid nur den Leer-Text — dann gibt es keine
    // Dropdown-Hüllen und es ist nichts zu verdrahten.
    this.shell = root.querySelector('[data-vf-select="brand"]');
    if (!this.shell) return;

    this.brand = new VfSelect(root.querySelector('[data-vf-select="brand"]'), {
      onPick: function (o, user) { self.onBrand(o, user); },
    });
    this.model = new VfSelect(root.querySelector('[data-vf-select="model"]'), {
      onPick: function (o, user) { self.onModel(o, user); },
    });
    this.type = new VfSelect(root.querySelector('[data-vf-select="type"]'), {
      onPick: function (o, user) { self.onType(o, user); },
    });

    this.bind();
    this.start();
  }

  Finder.prototype.buildHsnMap = function () {
    var map = {};
    this.vehicles.forEach(function (v) {
      if (!v.hsn) return;
      if (!map[v.hsn]) map[v.hsn] = [];
      map[v.hsn].push(v);
    });
    return map;
  };

  Finder.prototype.bind = function () {
    var self = this;

    this.tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { self.selectTab(i); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % self.tabs.length;
        if (e.key === 'ArrowLeft') next = (i - 1 + self.tabs.length) % self.tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = self.tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        self.selectTab(next);
        self.tabs[next].focus();
      });
    });

    if (this.submit) {
      this.submit.addEventListener('click', function () { self.go(); });
    }
    if (this.kbaSubmit) {
      this.kbaSubmit.addEventListener('click', function () { self.matchKba(true); });
    }
    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', function () { self.reset(); });
    }

    if (this.helpBtn && this.helpBox) {
      // Der Hinweis steht im HSN/TSN-Panel — also dorthin wechseln, sonst
      // klickt der Kunde auf „?" und es passiert scheinbar nichts.
      this.helpBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        // Auch „Panel ist gar nicht sichtbar" zählt als eingeklappt, sonst
        // blendet der erste Klick nach einem Reiterwechsel die Hilfe aus.
        var show = self.helpBox.hidden || self.panels[1].hidden;
        self.selectTab(1);
        self.helpBox.hidden = !show;
        self.helpBtn.setAttribute('aria-expanded', String(show));
        if (show && self.hsnInput && !isMobile()) self.hsnInput.focus();
      });
    }

    if (this.hsnInput) {
      /* „0005 CLH" oder „0005/CLH" in einem Rutsch eingefügt auf beide Felder
         verteilen. Muss am paste-Event hängen: maxlength kürzt den Wert sonst
         schon, bevor ein input-Handler ihn sehen könnte. */
      var onPaste = function (e) {
        var cb = e.clipboardData || window.clipboardData;
        var txt = cb ? cb.getData('text') || '' : '';
        // Beschriftungen wegräumen, sonst landet aus „HSN 0005 TSN CLH"
        // das Wort „TSN" als Typschlüsselnummer im Feld.
        txt = txt.replace(/\b(hsn|tsn)\b/gi, ' ').replace(/2\s*\.\s*[12]/g, ' ');
        // Trenner optional: „0005CLH" ist genauso gemeint wie „0005/CLH".
        var m = txt.match(/(\d{4})\s*[\/\-.\s]*\s*([A-Za-z0-9]{3})/);
        if (!m) return;
        e.preventDefault();
        self.hsnInput.value = m[1];
        self.tsnInput.value = m[2].toUpperCase();
        self.paintKbaFields();
        self.matchKba(true);
        self.tsnInput.focus();
      };
      this.hsnInput.addEventListener('paste', onPaste);
      this.tsnInput.addEventListener('paste', onPaste);

      this.hsnInput.addEventListener('input', function () {
        self.hsnInput.value = self.hsnInput.value.replace(/\D/g, '').slice(0, 4);
        if (self.hsnInput.value.length === 4) self.tsnInput.focus();
        self.paintKbaFields();
        self.matchKba(false);
      });

      this.tsnInput.addEventListener('input', function () {
        self.tsnInput.value = self.tsnInput.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 3);
        self.paintKbaFields();
        self.matchKba(false);
      });

      this.tsnInput.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && !self.tsnInput.value) self.hsnInput.focus();
        if (e.key === 'Enter') { e.preventDefault(); self.matchKba(true); }
      });
      this.hsnInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self.matchKba(true); }
      });
    }

    if (this.recentClear) {
      this.recentClear.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        try { localStorage.removeItem(STORE_KEY); } catch (err) {}
        self.recent.hidden = true;
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.helpBox && !self.helpBox.hidden) {
        self.helpBox.hidden = true;
        if (self.helpBtn) self.helpBtn.setAttribute('aria-expanded', 'false');
      }
    });
  };

  /* --- Tabs -------------------------------------------------------------- */
  Finder.prototype.selectTab = function (i) {
    // Eine Meldung aus dem anderen Reiter würde hier dem Sichtbaren
    // widersprechen; der „?"-Hinweis lebt im HSN/TSN-Panel.
    if (this.currentTab !== i) this.hideStatus();
    this.currentTab = i;
    if (i !== 1 && this.helpBtn) this.helpBtn.setAttribute('aria-expanded', 'false');
    this.tabs.forEach(function (t, k) {
      t.setAttribute('aria-selected', String(k === i));
      t.tabIndex = k === i ? 0 : -1;
    });
    this.panels.forEach(function (p, k) { p.hidden = k !== i; });
  };

  /* --- Kaskade ----------------------------------------------------------- */
  Finder.prototype.brandOptions = function () {
    var seen = {};
    var out = [];
    this.vehicles.forEach(function (v) {
      if (!v.b || seen[v.b]) return;
      seen[v.b] = true;
      out.push(v.b);
    });
    out.sort(function (a, b) { return a.localeCompare(b, 'de'); });
    var self = this;
    return out.map(function (b) {
      var n = self.modelOptions(b).length;
      return { value: b, name: b, meta: n === 1 ? '1 Modell' : n + ' Modelle' };
    });
  };

  Finder.prototype.modelOptions = function (brand) {
    var seen = {};
    var out = [];
    this.vehicles.forEach(function (v) {
      if (v.b !== brand || !v.m || seen[v.m]) return;
      seen[v.m] = true;
      out.push(v.m);
    });
    out.sort(function (a, b) { return a.localeCompare(b, 'de', { numeric: true }); });
    var self = this;
    return out.map(function (m) {
      var group = self.vehicles.filter(function (v) { return v.b === brand && v.m === m; });
      var codes = group.map(function (v) { return v.t; }).filter(Boolean);
      return {
        value: m,
        name: m,
        meta: codes.length ? codes.join(' · ') : null,
        alt: codes.join(' '),
        thumb: group[0] && group[0].img ? group[0].img : null,
      };
    });
  };

  Finder.prototype.typeOptions = function (brand, model) {
    var group = this.vehicles.filter(function (v) { return v.b === brand && v.m === model; });
    // Fahrzeuge ohne Chassis-Code NICHT herausfiltern — sie wären sonst über
    // die Kaskade unerreichbar. Stattdessen Baujahr bzw. Name als Ersatz.
    return group
      .map(function (v) {
        return {
          value: v.h,
          // Ohne Chassis-Code den Fahrzeugnamen zeigen — ein Baujahr als
          // „Typ" wäre für den Kunden nicht einzuordnen.
          name: v.t || v.n,
          meta: [v.y, v.parts ? parts(v.parts) : null].filter(Boolean).join(' · ') || null,
          alt: v.n,
          thumb: v.img || null,
        };
      })
      .sort(function (a, b) { return a.name.localeCompare(b.name, 'de', { numeric: true }); });
  };

  Finder.prototype.onBrand = function (opt, user) {
    if (user) this.touched = true;
    var options = this.modelOptions(opt.value);
    this.model.setOptions(options);
    this.type.setOptions([], { locked: true });
    this.setVehicle(null);

    if (options.length === 1 && this.autoSelectSingle) {
      this.model.pick(options[0].value, false, true);
      this.onModel(options[0], user);
      return;
    }
    if (user) this.model.openPop();
    this.announce(opt.name + ' gewählt. ' + options.length + (options.length === 1 ? ' Modell' : ' Modelle') + ' verfügbar.');
  };

  Finder.prototype.onModel = function (opt, user) {
    if (user) this.touched = true;
    var brand = this.brand.value;
    var options = this.typeOptions(brand, opt.value);
    var group = this.vehicles.filter(function (v) { return v.b === brand && v.m === opt.value; });

    // Genau ein Fahrzeug ohne Chassis-Code? Dann ist der dritte Schritt
    // überflüssig — direkt auflösen und den Fokus weiterreichen.
    if (group.length === 1 && !group[0].t) {
      this.type.setOptions([], { locked: true, lockedText: 'Nicht nötig' });
      this.setVehicle(group[0]);
      if (user && this.submit && !this.submit.disabled) this.submit.focus();
      return;
    }

    this.type.setOptions(options);
    this.setVehicle(null);

    if (options.length === 1 && this.autoSelectSingle) {
      this.type.pick(options[0].value, false, true);
      this.onType(options[0], user);
      return;
    }
    if (user) this.type.openPop();
    this.announce(opt.name + ' gewählt. ' + options.length +
      (options.length === 1 ? ' Typ' : ' Typen') + ' verfügbar.');
  };

  Finder.prototype.onType = function (opt, user) {
    if (user) this.touched = true;
    var v = this.byHandle(opt.value);
    this.setVehicle(v);
    if (user && this.submit && !this.submit.disabled) this.submit.focus();
  };

  Finder.prototype.byHandle = function (h) {
    for (var i = 0; i < this.vehicles.length; i++) {
      if (this.vehicles[i].h === h) return this.vehicles[i];
    }
    return null;
  };

  /* --- Ergebnis ---------------------------------------------------------- */
  Finder.prototype.setVehicle = function (v, source) {
    this.current = v || null;
    this.currentSource = v ? (source || 'cascade') : null;
    if (this.submit) this.submit.disabled = !v;
    if (this.resetBtn) this.resetBtn.hidden = !this.touched;

    if (!v) {
      if (this.result) this.result.hidden = true;
      return;
    }
    this.hideStatus();
    if (this.result) {
      this.result.hidden = false;
      if (this.resultImg) {
        this.resultImg.hidden = !v.img;
        if (v.img) { this.resultImg.src = v.img; this.resultImg.alt = v.n; }
      }
      if (this.resultName) this.resultName.textContent = v.n;
      if (this.resultMeta) {
        this.resultMeta.textContent =
          [v.y, v.parts ? parts(v.parts) + ' passend' : null].filter(Boolean).join(' · ') ||
          'Alle passenden Teile ansehen';
      }
      // result und resultGo sind dasselbe Element: die Karte IST der Link
      if (this.resultGo) this.resultGo.href = v.u;
    }
    this.announce(v.n + ' gefunden. ' + (v.parts ? parts(v.parts) + ' passend.' : ''));
  };

  Finder.prototype.go = function () {
    if (!this.current) return;
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({ h: this.current.h, n: this.current.n, u: this.current.u }));
    } catch (err) {}
    window.location.href = this.current.u;
  };

  Finder.prototype.reset = function () {
    this.touched = false;
    this.brand.setOptions(this.brandOptions());
    this.model.setOptions([], { locked: true });
    this.type.setOptions([], { locked: true });
    this.setVehicle(null);
    this.hideStatus();
    if (this.hsnInput) { this.hsnInput.value = ''; this.tsnInput.value = ''; this.paintKbaFields(); }
    if (this.resetBtn) this.resetBtn.hidden = true;
    this.autoPickSingleBrand();
    // Fokus in das SICHTBARE Panel legen — sonst landet er im Nichts.
    var target = (this.panels[0] && this.panels[0].hidden && this.hsnInput)
      ? this.hsnInput
      : this.brand.trigger;
    if (target && !target.disabled) target.focus();
  };

  Finder.prototype.announce = function (msg) {
    if (this.live) this.live.textContent = msg;
  };

  Finder.prototype.showStatus = function (title, text, actions) {
    if (!this.status) return;
    this.touched = true;
    if (this.resetBtn) this.resetBtn.hidden = false;
    if (this.result) this.result.hidden = true;
    // Erst befüllen, dann einblenden: role="alert" sagt sonst noch den Text
    // der vorherigen Meldung an.
    if (this.statusTitle) this.statusTitle.textContent = title;
    if (this.statusText) this.statusText.textContent = text;
    if (this.statusActions) {
      this.statusActions.textContent = '';
      (actions || []).forEach(function (a) {
        var el = document.createElement(a.href ? 'a' : 'button');
        el.className = 'bos-vf__status-btn';
        if (a.href) el.href = a.href;
        else el.type = 'button';
        el.textContent = a.label;
        if (a.onClick) el.addEventListener('click', a.onClick);
        this.statusActions.appendChild(el);
      }, this);
    }
    this.status.hidden = false;
  };

  Finder.prototype.hideStatus = function () {
    if (this.status) this.status.hidden = true;
  };

  /* --- HSN / TSN --------------------------------------------------------- */
  Finder.prototype.paintKbaFields = function () {
    if (!this.hsnInput) return;
    this.hsnInput.parentElement.classList.toggle('bos-vf-field--ok', this.hsnInput.value.length === 4);
    this.tsnInput.parentElement.classList.toggle('bos-vf-field--ok', this.tsnInput.value.length === 3);
    if (this.kbaSubmit) {
      this.kbaSubmit.disabled = !(this.hsnInput.value.length === 4 && this.tsnInput.value.length === 3);
    }
  };

  Finder.prototype.matchKba = function (explicit) {
    if (!this.hsnInput) return;
    var hsn = this.hsnInput.value;
    var tsn = this.tsnInput.value;
    if (hsn.length !== 4 || tsn.length !== 3) {
      if (explicit) {
        this.showStatus(
          'Nummern noch nicht komplett.',
          'Die HSN hat 4 Stellen (Feld 2.1), die TSN 3 Stellen (Feld 2.2) in deiner Zulassungsbescheinigung Teil I.'
        );
      } else {
        this.hideStatus();
        // Nur einen Treffer AUS DIESEM Reiter zurücknehmen. Sonst würde eine
        // einzelne getippte Ziffer die fertige Auswahl der Autosuche löschen
        // und dort gefüllte Felder mit totem Button hinterlassen.
        if (this.currentSource === 'kba') this.setVehicle(null);
      }
      return;
    }

    var byHsn = this.hsnMap[hsn] || [];
    var exact = byHsn.filter(function (v) {
      return (v.tsn || []).some(function (t) { return String(t).toUpperCase() === tsn; });
    });

    if (exact.length === 1) {
      // Erst die Dropdowns mitziehen, dann das Ergebnis setzen
      this.syncSelectsTo(exact[0]);
      this.setVehicle(exact[0], 'kba');
      return;
    }

    // Dieselbe Schlüsselnummer an mehreren Fahrzeugen (z. B. Limousine und
    // Touring): nicht raten, sondern auswählen lassen.
    if (exact.length > 1) {
      var self0 = this;
      this.syncSelectsTo(exact[0]);
      this.type.setOptions(exact.map(function (v) {
        return {
          value: v.h,
          name: v.t || v.n,
          meta: [v.n, v.parts ? parts(v.parts) : null].filter(Boolean).join(' · '),
          alt: v.n,
          thumb: v.img || null,
        };
      }));
      this.setVehicle(null);
      this.showStatus(
        'Mehrere Fahrzeuge zu ' + hsn + ' / ' + tsn + '.',
        'Zu dieser Schlüsselnummer passen ' + exact.length + ' Varianten. Wähle die richtige aus.',
        [{ label: 'Variante wählen', onClick: function () { self0.selectTab(0); self0.type.openPop(); } }]
      );
      return;
    }

    var self = this;
    if (byHsn.length) {
      var brandName = byHsn[0].b;
      this.setVehicle(null);
      this.showStatus(
        'Marke erkannt: ' + brandName + '.',
        'Die TSN ' + tsn + ' ist bei uns noch nicht hinterlegt. Wähle dein Modell direkt aus — das dauert zwei Klicks.',
        [{
          label: brandName + '-Modelle wählen',
          onClick: function () {
            self.selectTab(0);
            self.brand.pick(brandName, false, true);
            self.onBrand({ value: brandName, name: brandName }, true);
          },
        }]
      );
      return;
    }

    this.setVehicle(null);
    this.showStatus(
      'Kein Fahrzeug zu ' + hsn + ' / ' + tsn + ' gefunden.',
      'Wir führen aktuell nicht für jedes Fahrzeug Teile. Schau in der Autosuche, welche Modelle verfügbar sind — oder frag uns, wir prüfen es für dich.',
      [
        { label: 'Zur Autosuche', onClick: function () { self.selectTab(0); self.brand.trigger.focus(); } },
        { label: 'Fahrzeug anfragen', href: '/pages/contact' },
      ]
    );
  };

  /* Dropdowns auf ein Fahrzeug stellen, ohne die Kaskade auszulösen — damit
     HSN/TSN-Treffer und URL-Vorbelegung denselben Zustand zeigen. */
  Finder.prototype.syncSelectsTo = function (v) {
    if (!v) return;
    this.touched = true;
    this.brand.setOptions(this.brandOptions());
    this.brand.pick(v.b, false, true);
    this.model.setOptions(this.modelOptions(v.b));
    this.model.pick(v.m, false, true);
    var types = this.typeOptions(v.b, v.m);
    if (types.length) {
      this.type.setOptions(types);
      this.type.pick(v.h, false, true);
    } else {
      this.type.setOptions([], { locked: true, lockedText: 'Nicht nötig' });
    }
    if (this.resetBtn) this.resetBtn.hidden = false;
  };

  /* --- Start ------------------------------------------------------------- */
  Finder.prototype.autoPickSingleBrand = function () {
    var brands = this.brandOptions();
    if (brands.length === 1 && this.autoSelectSingle) {
      this.brand.pick(brands[0].value, false, true);
      this.onBrand(brands[0], false);
    }
  };

  Finder.prototype.start = function () {
    if (!this.vehicles.length) return;

    this.brand.setOptions(this.brandOptions());
    this.paintKbaFields();
    this.restoreRecent();

    var p = new URLSearchParams(window.location.search);
    var pre = this.fromParams(p);
    if (pre) {
      this.syncSelectsTo(pre);
      this.setVehicle(pre);
      return;
    }

    var hsn = (p.get('hsn') || '').replace(/\D/g, '').slice(0, 4);
    var tsn = (p.get('tsn') || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 3);
    if (hsn && tsn && this.hsnInput) {
      this.selectTab(1);
      this.hsnInput.value = hsn;
      this.tsnInput.value = tsn;
      this.paintKbaFields();
      this.matchKba(true);
      return;
    }

    this.autoPickSingleBrand();
  };

  /* Vorbelegung per URL: ?marke=BMW&modell=3er&typ=G20 — und `?q=` aus der
     alten Suche wird als Freitext auf ein Fahrzeug gematcht. */
  Finder.prototype.fromParams = function (p) {
    var wantB = norm(p.get('marke') || p.get('brand') || '');
    var wantM = norm(p.get('modell') || p.get('model') || '');
    var wantT = norm(p.get('typ') || p.get('type') || '');
    var q = norm(p.get('q') || '');

    if (wantB || wantM || wantT) {
      var hit = this.vehicles.filter(function (v) {
        return (!wantB || norm(v.b) === wantB) &&
          (!wantM || norm(v.m) === wantM) &&
          (!wantT || norm(v.t).indexOf(wantT) !== -1);
      });
      if (hit.length === 1) return hit[0];
      if (hit.length > 1 && wantB) {
        this.brand.pick(hit[0].b, false, true);
        this.onBrand({ value: hit[0].b, name: hit[0].b }, false);
        return null;
      }
    }

    if (q) {
      var exact = this.vehicles.filter(function (v) { return norm(v.n) === q || norm(v.h) === q; });
      if (exact.length) return exact[0];
      var loose = this.vehicles.filter(function (v) {
        return norm(v.n + ' ' + v.t + ' ' + v.h).indexOf(q) !== -1;
      });
      if (loose.length === 1) return loose[0];
    }
    return null;
  };

  Finder.prototype.restoreRecent = function () {
    if (!this.recent) return;
    var raw = null;
    try { raw = localStorage.getItem(STORE_KEY); } catch (err) { return; }
    if (!raw) return;
    var saved;
    try { saved = JSON.parse(raw); } catch (err) { return; }
    // Nur anzeigen, wenn das Fahrzeug noch existiert
    var v = saved && saved.h ? this.byHandle(saved.h) : null;
    if (!v) { try { localStorage.removeItem(STORE_KEY); } catch (err) {} return; }
    this.recent.hidden = false;
    if (this.recentLink) this.recentLink.href = v.u;
    if (this.recentName) this.recentName.textContent = v.n;
  };

  /* ======================================================================== */
  function init(scope) {
    (scope || document).querySelectorAll('[data-vf-root]').forEach(function (root) {
      if (root.dataset.vfReady) return;
      root.dataset.vfReady = '1';
      try {
        new Finder(root);
      } catch (err) {
        // Lieber eine funktionslose, aber sichtbare Karte als eine leere Seite
        if (window.console) console.error('[bos-vehicle-finder]', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme-Editor: Section wird neu gerendert
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
